<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">


    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
       <input 
          type="text" 
          v-model="searchQuery" 
          @input="filterPermissions" 
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          :placeholder="$t('permissions.searchPlaceholder')"
        />
      </div>
      <div class="d-flex align-items-center">
         <router-link to="/permissions/add/null" class="sidebar-sub-menu-link">
          <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            type="button"
            style="background-color: #EB9355;"
            v-if="current_permissions('create_permission')"
          >
            {{ $t('permissions.addPermission') }}
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </router-link>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('permissions.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('permissions.permission') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('permissions.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('permissions.viewActions') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="paginatedPermissions.length === 0">
              <td colspan="5" class="text-center py-5 text-muted">
                {{ $t('permissions.noResults') }}
              </td>
            </tr>
            <tr v-for="(permission) in paginatedPermissions" :key="permission.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ permission.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ permission.name === null ? '' : permission.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ permission.description === null ? '' : permission.description }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis text-center">
                <div class="dropdown" v-if="permission.actions !== null && permission.actions.length > 0">
                  <button class="btn btn-none dropdown-toggle border-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-eye"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li v-for="(action) in permission.actions" :key="action.code">
                      <a class="dropdown-item" href="javascript:void(0)">{{ action.route }}</a>
                    </li>
                  </ul>
                </div>
                <span v-else class="text-muted fs-13">{{ $t('permissions.noActions') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <router-link :to="`/permissions/add/${permission.code}`" class="sidebar-sub-menu-link" style="text-decoration: none;">
                  <i class="flaticon-pen"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination côté client -->
      <div v-if="filteredPermissions.length > 0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p class="mb-0 text-paragraph">
          {{ $t('permissions.showing') }} <span class="fw-bold">{{ filteredPermissions.length > 0 ? Math.min((page-1)*itemsPerPage + 1, filteredPermissions.length) : 0 }}</span>
          {{ $t('permissions.to') }} <span class="fw-bold">{{ Math.min(page*itemsPerPage, filteredPermissions.length) }}</span>
          {{ $t('permissions.outOf') }}
          <span class="fw-bold">{{ filteredPermissions.length }}</span> {{ $t('permissions.results') }}
        </p>
        <nav class="mt-15 mt-md-0" v-if="numPages > 1">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="setPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in paginationPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="setPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="setPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Permission -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('permissions.addPermission') : $t('permissions.editPermission') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('permissions.permission') }}</label>
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('permissions.namePlaceholder')" @blur="validate('name')" @keyup="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('permissions.description') }}</label>
                  <div>
                    <input v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('permissions.descriptionPlaceholder')" @blur="validate('description')" @keyup="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }" />
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('permissions.actions') }}</label>
                  <div class="row">
                    <div v-for="action in actionsTemp" :key="action.code" class="form-check mb-2 col-md-4" :title="action.description">
                      <input class="form-check-input" type="checkbox" :id="'action-' + action.code" :value="action.route" v-model="selectedActions" />
                      <label class="form-check-label text-black" :for="'action-' + action.code">
                        {{ action.route }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_operator', 'edit_operator')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ edit == 0 ? $t('permissions.save') : $t('permissions.edit') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { showToast, checkSessionValidate } from "../../utils/function";
import { current_permissions } from '../../utils/permission';
import { useRoute, useRouter } from 'vue-router'
import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import { Permissions, Actions } from "@/utils/Model";

const backApi = inject('back');
const { t } = useI18n();

let edit = 0;
let itemCode = '';
let code: string | null = '';

const selectedActions = ref([]);
const btnLoad = ref(true);

let token: string | null = localStorage.getItem('login_token');

// Références réactives
const permissionsTemp = ref(new Array<Permissions>());
const actionsTemp = ref(new Array<Actions>());

// Variables pour la recherche
const searchQuery = ref('');
const filteredPermissions = ref(new Array<Permissions>());

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'name': '', 'description': '' };
const pageLoad = ref(false);

const formValues = reactive({
  name: "",
  description: "",
});

const schema = yup.object({
  name: yup.string().required('Le nom de la permission est requis'),
  description: yup.string().required('La description est requise'),
});

// Pagination côté client
const page = ref(1);
const itemsPerPage = 10;

// Computed pour les données à afficher (filtrées ou non)
const dataToDisplay = computed(() => {
  return searchQuery.value ? filteredPermissions.value : permissionsTemp.value;
});

// Computed pour le total
const total = computed(() => dataToDisplay.value.length);

// Computed pour le nombre de pages
const numPages = computed(() => Math.max(1, Math.ceil(total.value / itemsPerPage)));

// Computed pour les pages de pagination
const paginationPages = computed(() => {
  const pages = [];
  const totalPages = numPages.value;
  const current = page.value;
  
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    if (current <= 3) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    } else if (current >= totalPages - 2) {
      pages.push(1);
      pages.push('...');
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      pages.push('...');
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    }
  }
  return pages;
});

// Computed pour les permissions paginées
const paginatedPermissions = computed(() => {
  const start = (page.value - 1) * itemsPerPage;
  return dataToDisplay.value.slice(start, start + itemsPerPage);
});

const setPage = (numPage) => {
  if (numPage >= 1 && numPage <= numPages.value) {
    page.value = numPage;
  }
};

// Méthode pour filtrer les permissions
const filterPermissions = () => {
  const query = searchQuery.value.toLowerCase().trim();
  
  if (!query) {
    filteredPermissions.value = [...permissionsTemp.value];
    page.value = 1;
    return;
  }

  filteredPermissions.value = permissionsTemp.value.filter(permission => {
    // Recherche dans le code, le nom et la description
    const matchesBasic = (
      (permission.code && permission.code.toLowerCase().includes(query)) ||
      (permission.name && permission.name.toLowerCase().includes(query)) ||
      (permission.description && permission.description.toLowerCase().includes(query))
    );

    // Recherche dans les actions
    const matchesActions = permission.actions && permission.actions.some(action => 
      action.route && action.route.toLowerCase().includes(query)
    );

    return matchesBasic || matchesActions;
  });

  // Réinitialiser la page à 1 après un filtre
  page.value = 1;
};

// Méthode pour effacer la recherche
const clearSearch = () => {
  searchQuery.value = '';
  filteredPermissions.value = [...permissionsTemp.value];
  page.value = 1;
};

const initField = () => {
  formValues.name = '';
  formValues.description = "";
  selectedActions.value = [];
  itemCode = '';
  edit = 0;
  errorId.value = ''
  errors.value = ''
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

// Récupère une page depuis l'API (forme { data, pagination })
const fetchPermissionsPage = (targetPage: number) => {
  const url = `${backApi}/secure/permissions/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getPermissions = async () => {
  try {
    const first = await fetchPermissionsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchPermissionsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    permissionsTemp.value = collected.sort((a, b) => {
      const nameA = a.name ? a.name.toUpperCase() : '';
      const nameB = b.name ? b.name.toUpperCase() : '';
      return nameA.localeCompare(nameB);
    });
    filteredPermissions.value = [...permissionsTemp.value];
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getActions = () => {
  return axios.get(backApi + '/secure/actions/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      actionsTemp.value = response.data.sort((a, b) => {
        const routeA = a.route ? a.route.toUpperCase() : '';
        const routeB = b.route ? b.route.toUpperCase() : '';
        return routeA.localeCompare(routeB);
      });
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/operators/${code}/status`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showOperator = (code) => {
  axios.get(backApi + '/secure/actions/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.name = response.data.name;
      formValues.description = response.data.description;
      selectedActions.value = response.data.actions;
      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

const save = () => {
  if (edit == 0) {
    storePermission()
  } else {
    updatePermission()
  }
}

const storePermission = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/permissions/new`, {
      name: formValues.name,
      description: formValues.description,
      actions: selectedActions.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Permission " + formValues.name.toLowerCase() + " enregistré avec succès", "green");
        initField();
        setTimeout(() => {
          router.go();
        }, 500);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

const updatePermission = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/operators/${itemCode}/edit`, {
      name: formValues.name,
      description: formValues.description,
      actions: selectedActions
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

onMounted(async () => {
  checkSessionValidate(1)
  const route = useRoute();
  code = route.params.id;

  try {
    await Promise.all([
      getPermissions(),
      getActions(),
    ]);
  } finally {
    pageLoad.value = true;
  }
});
</script>